import { z } from "zod"

import { weeklyFormSchema } from "../validation"

/**
 * Result summary (without intervals array to save storage space)
 */
const weeklyResultSummarySchema = z.object({
  agentsFte: z.number(),
  agentsPer30MinsMax: z.number(),
  callsPer30MinsMax: z.number(),
  callsPerWeek: z.number(),
})

export type WeeklyResultSummary = z.infer<typeof weeklyResultSummarySchema>

/**
 * Persisted calculation structure for weekly calculator
 */
export const weeklySavedCalculationSchema = z.object({
  version: z.literal(1),
  formValues: weeklyFormSchema,
  result: weeklyResultSummarySchema.nullable(),
  advancedOpen: z.boolean(),
  status: z.enum(["idle", "complete"]),
})

export type WeeklySavedCalculation = z.infer<typeof weeklySavedCalculationSchema>

export const WEEKLY_STORAGE_KEY = "erlang-calculator:weekly:last-calculation"
